import script from "./FormDropFile.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDropFile.vue?vue&type=script&setup=true&lang=js"

import "./FormDropFile.vue?vue&type=style&index=0&id=5cb38146&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb38146"]])

export default __exports__